var render = function render(){var _vm=this,_c=_vm._self._c;return _c("style",{tag:"div"},[_vm._v(_vm._s(_vm.style))])
}
var staticRenderFns = []

export { render, staticRenderFns }